 /**
   * Rewrites the language selector menu heading text to match the current site
   * as identified by Smartling tags.
   */
const smartlingMenuFix = () => {
    const classes = $('body').attr('class').split(' ');
    const smartlingClass = _.find(
        classes,
        (bodyClass) => bodyClass.indexOf('smartling') > -1,
    );
    if (!_.isUndefined(smartlingClass) && !_.isNull(smartlingClass)) {
        const smartlingLang = smartlingClass.split('-')[1];
        const menuItems = $('#menu-language-selector .menu-item a');
        const match = _.find(
            menuItems,
            (item) => $(item).attr('href').indexOf(smartlingLang) > -1,
        );
        if (match) {
            $('.update-header').text($(match).text().replace(/\(|\)/gi, ''));
        }
    }
};

const onLangSelectorClick = (e) => {
    e.preventDefault();
    // Deactivate the search if that is active.
    $('.header-search')
        .removeClass('active');
    $('.top-navigation .js-smt-lang-selector')
        .toggleClass('active');
    $('#mobile-menu .js-smt-lang-selector .smt-trigger')
        .toggleClass('active');
};

(($) => {
    smartlingMenuFix();
    $('.smt-trigger-link').on('click', (e) => onLangSelectorClick(e));
})(jQuery);
